import {
    GET_GST_REGESTER_REPORT_PROGRESS, GET_GST_REGESTER_REPORT_SUCCESS, GET_GST_REGESTER_REPORT_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    GSTRegister: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const gst_register_report_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_GST_REGESTER_REPORT_SUCCESS:
            return { ...state, GSTRegister: action.GSTRegister, loading: false };
        case GET_GST_REGESTER_REPORT_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_GST_REGESTER_REPORT_PROGRESS:
            return { ...state, loading: true, error: false };
        case RESET_MESSAGE:
            return { ...state, message: null };
        default:
            return state
    }
}

export default gst_register_report_reducer;